//
//
//
//
//


export default {
    data () {
        return {
            show_dlg: false,
            show: false
        }
    },
    mounted () {
    },
    methods: {
    }
}
